import {Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {CellComponent} from '@shared/components/cell-components/cell-component';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {FieldDefinition} from '@shared/models/field-definition';
import {TaskManagerService} from '../../../services/task-manager.service';
import {Store} from '@ngrx/store';
import {IQueryState} from '@shared/store/reducers/query.reducer';
import {GraphQLService} from '@core/services/graphql.service';
import {Subject} from 'rxjs';
import {GraphqlContentScope} from '@shared/models/graphql-content-scope.model';
import {take} from 'rxjs/operators';
import {TaskManagerState} from '../../../store/task-manager.reducer';
import {TaskManagerConfig} from '../../../helpers/task-manager.config';
import {TaskManagerQuery} from '../../../helpers/task-manager.query';
import {GetSelectedBoardAction} from '../../../store/task-manager.action';

@Component({
    standalone: false,
    selector: 'particle-task-auto-create-cell-viewer',
  templateUrl: './task-auto-create-cell-viewer.component.html',
  styleUrls: ['./task-auto-create-cell-viewer.component.scss']
})
export class TaskAutoCreateCellViewerComponent implements OnInit, CellComponent, OnDestroy {
  invalidateSubject?: InvalidateSubject;
  item: any;
  taskInfo: any;
  fieldDefinition: FieldDefinition;
  sourceType: string;
  disabled: boolean;
  status: string;
  boardType: string;
  description: string;
  title: string;
  scope: number;
  unsubscribe$ = new Subject<void>();
  @Output() valueChanged: EventEmitter<any> = new EventEmitter();

  constructor(private taskManagerService: TaskManagerService,
              private store: Store<IQueryState>,
              private taskManagerStore: Store<TaskManagerState>,
              private graphQLService: GraphQLService) {
    this.disabled = false;
    this.status = 'Pending';
    this.boardType = '';
    this.description = '';
    this.title = 'Untitled';
    this.scope = 0;
  }

  ngOnInit() {
    this.boardType = this.fieldDefinition.metaData.BoardType;

    if (this.fieldDefinition && this.fieldDefinition.metaData) {
      if (this.fieldDefinition.metaData.TitleFieldKey) {
        const titleFieldKey = this.fieldDefinition.metaData.TitleFieldKey;
        if (this.item.cells && this.item.cells[titleFieldKey] && this.item.cells[titleFieldKey].displayText) {
          this.title = this.item.cells[titleFieldKey].displayText;
        }
      }

      if (this.fieldDefinition.metaData.Status) {
        this.status = this.fieldDefinition.metaData.Status;
      }

      if (this.fieldDefinition.metaData.Scope) {
        this.scope = parseInt(this.fieldDefinition.metaData.Scope);
      }
    }
  }

  openTask() {
    if (this.item.cells[this.fieldDefinition.key] && this.item.cells[this.fieldDefinition.key].displayText) {
      console.log('Open Task');
      const task = this.item.cells[this.fieldDefinition.key].value;
      if (task && task.ticketId && task.boardScope) {
        this.taskManagerService.openTaskByTaskId(task.ticketId, GraphqlContentScope.getScope(task.boardScope))
          .pipe(take(1)).subscribe(state => {
          this.valueChanged.emit({item: this.item, fieldDefinition: this.fieldDefinition, action: {id: 'TaskClosed'}});
        });
      } else {
        this.valueChanged.emit({item: this.item, fieldDefinition: this.fieldDefinition, action: {id: 'OpenTask'}});
      }
    } else {
      console.error('Error opening task', this.item);
    }
  }

  attachToNewTask() {
    this.taskManagerService.createTask(this.boardType, this.status, this.title, this.description).pipe(take(1)).subscribe((selectedTask: any) => {
      // NOTE: Converting case of keys to keep it consistent
      const clonedTask = {};
      Object.keys(selectedTask).forEach(key => {
        const lowerCaseKey = `${key[0].toLowerCase()}${key.substr(1)}`;
        clonedTask[lowerCaseKey] = selectedTask[key];
      });

      this.valueChanged.emit({
        item: this.item,
        fieldDefinition: this.fieldDefinition,
        action: {id: 'AttachTask'},
        payload: clonedTask
      });
    });
  }

  attachToExistingTask() {
    this.taskManagerService.openTaskSelector().pipe(take(1)).subscribe(selectedTask => {
      this.valueChanged.emit({
        item: this.item,
        fieldDefinition: this.fieldDefinition,
        action: {id: 'AttachTask'},
        payload: selectedTask
      });
    });
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
